import React from "react";
import BranchCard from "./BranchCard";

interface BranchListProps {
  branches: any[];
  showDeletedBranches: boolean;
  onEdit: (branch: any) => void;
  onDelete: (id: string) => void;
}

const BranchList: React.FC<BranchListProps> = ({ branches, showDeletedBranches, onEdit, onDelete }) => {
  if (branches.length === 0) return <p>No data available</p>;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 flex-grow gap-[30px] w-[96%] overflow-y-auto 
                    scrollbar-thin h-full scrollbar-thumb-gray-300 scrollbar-track-transparent shadow-inner rounded-lg p-2 bg-white">
      {branches.map((branch) => (
        <BranchCard
          key={branch._id.$oid}
          branch={branch}
          onEdit={onEdit}
          onDelete={onDelete}
          showDeletedBranches={showDeletedBranches}
        />
      ))}
    </div>
  );
};

export default BranchList;
